<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>分类名称：</label>
                <el-input v-model="search_Obj.f_cate_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>状态：</label>
                <el-select v-model="search_Obj.f_state" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('show_state')" :key="'showstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="cate_name" label="分类名称" sortable="custom"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "show_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_index" label="排序" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import listutil from "@/libs/listutil"

export default {
    name: 'momentCateList',
    mixins: [listutil],
    components: {Edit, Btns, LabBtns},
    data() {
        return {
            m_name: '动态分类',
            menu_id: 8200,
            list_url: "/api/admin/momentcate/list",
            search_Obj: {
                f_cate_name: '',
                f_state: '',
            },
            del_Obj:{
                url:'/api/admin/momentcate/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['show_state'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
        };
    },
    methods: {}
};
</script>